export default __webpack_public_path__ + "static/media/createNewPlusIcon.bdaef39d.svg";